import { render, staticRenderFns } from "./RouteChannelInfo.vue?vue&type=template&id=35ef02c6&scoped=true&"
import script from "./RouteChannelInfo.vue?vue&type=script&lang=js&"
export * from "./RouteChannelInfo.vue?vue&type=script&lang=js&"
import style0 from "./RouteChannelInfo.vue?vue&type=style&index=0&id=35ef02c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ef02c6",
  null
  
)

export default component.exports